module.exports = __webpack_public_path__ + "static/img/19097B_1_2_R_20200908_fit.dbc80c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19097B_1_2_R_20200908_fit.png
// module id = 1HYh
// module chunks = 0